/**
 * loop.js
 * Vòng lặp render chính (Main Animation Loop) của Voxel Anim Studio.
 * Hỗ trợ cờ window.__PAUSE_ANIMATION__ phục vụ Visual Snapshot Testing.
 */

import { advanceWalker } from './modes/walker-controller.js';

export function startAnimationLoop(state) {
  let frameCount = 0;

  function animate() {
    requestAnimationFrame(animate);

    const isPaused = Boolean(window.__PAUSE_ANIMATION__);
    const delta = isPaused ? 0 : state.clock ? state.clock.getDelta() : 0;

    // Shadow Map Cadence: cập nhật cách 1 frame khi chuyển động, cập nhật liên tục khi chụp snapshot
    if (state.renderer && state.renderer.shadowMap && state.renderer.shadowMap.enabled) {
      if (isPaused) {
        state.renderer.shadowMap.needsUpdate = true;
      } else {
        frameCount++;
        state.renderer.shadowMap.needsUpdate = frameCount % 2 === 0;
      }
    }

    if (!isPaused) {
      // Cập nhật tất cả các avatar đang hoạt động
      if (state.activeAvatars) {
        state.activeAvatars.forEach((av) => {
          av.update(delta);

          // Cập nhật vị trí di chuyển cho NPC ở Walker Mode nếu có walkerController
          if (av.walkerController) {
            advanceWalker(av, delta);
          }
        });
      }

      // Cập nhật xe cộ di chuyển trong Phố Phường VN
      if (state.movingVehicles) {
        state.movingVehicles.forEach((v) => {
          v.obj.position.x += v.speed * v.dir * delta;
          const wheels = v.obj.userData.wheels;
          if (wheels) {
            const spin = (v.speed * delta) / v.obj.userData.wheelRadius;
            wheels.forEach((w) => {
              w.rotation.z -= spin;
            });
          }
          if (v.dir > 0 && v.obj.position.x > v.maxX) {
            v.obj.position.x = v.minX;
          } else if (v.dir < 0 && v.obj.position.x < v.minX) {
            v.obj.position.x = v.maxX;
          }
        });
      }

      // Cập nhật hoạt cảnh nếu đang ở chế độ kịch bản
      if (state.currentMode === 'drama' && state.dramaDirector) {
        state.dramaDirector.update(delta);
      }
      if (state.storyboardDirector) {
        state.storyboardDirector.update(delta);
      }
      if (state.emotionEffectsManager) {
        state.emotionEffectsManager.update(delta);
      }

      if (state.controls) {
        state.controls.update();
      }
    }

    if (state.renderer && state.scene && state.camera) {
      state.renderer.render(state.scene, state.camera);
    }
  }

  animate();
}
